import { Box, Text } from '@mantine/core';
import { Link } from 'react-router-dom';
import styles from './Security.module.scss';
import { ReactComponent as KeyIcon } from './img/IconKey.svg';
import { ReactComponent as ArrowBackIcon } from './img/iconBackForward.svg';
import { ReactComponent as IconAlert } from './img/iconAlertRound.svg';
import { ReactComponent as IconShield } from './img/iconShield.svg';
import { ReactComponent as IconDoneSmall } from './img/iconDoneSmall.svg';
import { useState } from 'react';
import { ChangePassword } from './ChangePassword';
import { Logs } from './Logs';
import { Helmet } from 'react-helmet';
import { Button } from 'ui/Button';
import { Modal } from 'components/Modal';
import { Title } from 'components/Title';
import {
  useGetInfoUserQuery,
  useToggleTwoFAMutation,
} from 'redux/Api/profileApi/ProfileApi';

export const Security = () => {
  const { data: userData } = useGetInfoUserQuery();

  const [toggleTwoFA, { isLoading: togglingTwoFA }] = useToggleTwoFAMutation();

  const [isChangePasswordOpen, setIsChangePasswordOpen] = useState(false);
  const [showDisableTwoFAModal, setShowDisableTwoFAModal] = useState(false);

  const handleOpenChangePassword = () => {
    setIsChangePasswordOpen(true);
  };

  const handleCloseChangePassword = () => {
    setIsChangePasswordOpen(false);
  };

  return (
    <>
      <Helmet>
        <title>Безопасность</title>
      </Helmet>
      <div className={styles.security}>
        <Box mb={20}>
          <Link to='/profile' className={styles.backLink}>
            ← Профиль
          </Link>
          <Text fz='20px' fw={600} mt={8}>
            Безопасность
          </Text>
        </Box>

        <div className={styles.securitySection}>
          <div className={styles.leftSection}>
            {userData?.is_2fa_enabled ? (
              <div className={styles.twoFactorAuth_enabled}>
                <div className={styles.twoFactorAuth_enabled_header}>
                  <IconShield />
                  <span className={styles.twoFactorAuth_enabled_title}>
                    Двухфакторная авторизация
                  </span>
                </div>
                <div className={styles.toggleContainer}>
                  <label className={styles.toggle}>
                    <input
                      type='checkbox'
                      checked={userData?.is_2fa_enabled}
                      onChange={() => setShowDisableTwoFAModal(true)}
                      disabled={togglingTwoFA}
                    />
                    <span className={styles.slider}>
                      <IconDoneSmall className={styles.checkIcon} />
                    </span>
                  </label>
                </div>
              </div>
            ) : (
              <div className={styles.twoFactorAuth}>
                <span className={styles.twoFactorAuth_title}>
                  <IconAlert />
                  Двухфакторная авторизация
                </span>
                <div className={styles.twoFactorAuth_content}>
                  <IconAlert />
                  <span className={styles.twoFactorAuth_content_info}>
                    Включи двухфакторную авторизацию, чтобы защитить свой аккаунт от
                    несанкционированного доступа и повысить безопасность своих данных
                  </span>

                  <Button
                    className={styles.twoFactorAuth_btn}
                    loading={togglingTwoFA}
                    onClick={async () => {
                      try {
                        await toggleTwoFA().unwrap();
                      } catch (e) {
                        console.error('Не удалось переключить 2FA', e);
                      }
                    }}
                    theme='filed'>
                    Включить
                  </Button>
                </div>
              </div>
            )}

            <div className={styles.securityOption} onClick={handleOpenChangePassword}>
              <div className={styles.securityOption_content}>
                <KeyIcon />
                <Text fz='16px' fw='500' lh='22px'>
                  Сменить пароль
                </Text>
              </div>
              <ArrowBackIcon />
            </div>
          </div>

          <Logs />

          {/* <div className={styles.securityOption}>
          <Text>Сменить Email</Text>
          <ArrowIcon />
        </div> */}
        </div>
      </div>
      <ChangePassword isOpen={isChangePasswordOpen} onClose={handleCloseChangePassword} />
      {showDisableTwoFAModal && (
        <Modal setOpen={setShowDisableTwoFAModal}>
          <div className={styles.root}>
            <Title
              className={styles.root_title}
              title='Ты уверен, что хочешь отключить двухфакторную авторизацию?'
            />
            <p className={styles.root_text}>
              Двухфакторная авторизация нужна, чтобы защитить аккаунт от
              несанкционированного доступа и повысить безопасность данных
            </p>
            <div className={styles.root_btn}>
              <Button
                loading={togglingTwoFA}
                onClick={async () => {
                  try {
                    await toggleTwoFA().unwrap();
                    setShowDisableTwoFAModal(false);
                  } catch (e) {
                    console.error('Не удалось выключить 2FA', e);
                  }
                }}
                className={styles.root_btn_exit}
                theme='danger'>
                Отключить
              </Button>
              <Button
                onClick={() => setShowDisableTwoFAModal(false)}
                className={styles.root_btn_cancel}
                theme='filed'>
                Отмена
              </Button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};
